import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _toConsumableArray from "/app/node_modules/babel-runtime/helpers/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from "vuex";
import { required, minLength, numeric, maxLength } from "vuelidate/lib/validators";
import { InternalServerError } from "~/abstractions/errors";
import { stepForm, onlyNumbersMixin } from "~/mixins";
import { WarningError } from "~/abstractions/errors";
import loader from "../modals/loader";
import comisions from "../shared/table/comisions-table";
import template from "./functionals/autocomplete-template";
export default {
  mixins: [stepForm, onlyNumbersMixin],
  components: {
    loader: loader,
    comisions: comisions
  },
  data: function data() {
    var arreglo = [];
    var datitos = this.$store.state["master-data"].opCommercialBusiness;
    // console.log("@@@@@@@@@@@@@@@@@@@@@@@");
    // console.log(datitos);
    datitos.forEach(function (element) {
      // console.log("@@@@@@@@@@@@@@@@@@@@@@@");
      var e = element.Description;
      arreglo.push(e);
      // console.log(arreglo);
      // console.log("@@@@@@@@@@@@@@@@@@@@@@@");
      return arreglo;
    });

    var _$store$state$affilia = this.$store.state.affiliations.form.rucValidation,
        ruc = _$store$state$affilia.ruc,
        businessName = _$store$state$affilia.businessName,
        consultDate = _$store$state$affilia.consultDate;


    return {
      tableComision: false,
      ruc: ruc,
      businessName: businessName,
      consultDate: consultDate,
      loading: false,
      isSuccess: !!businessName,
      isValidate: !!businessName,
      isVisanetClient: false,
      invalidMessage: null,
      dialog: false,
      template: template,
      commercialBusiness: "",
      codeMcci: "",
      isSelectGiro: false,
      autoCompleteComercial: "",
      datitos: datitos,
      arreglo: arreglo
    };
  },

  validations: {
    ruc: {
      required: required,
      minLength: minLength(11),
      maxLength: maxLength(11),
      numeric: numeric
    }
  },
  methods: {
    setCodeMcci: function setCodeMcci(code) {
      // console.log(code);
      this.codeMcci = code;
      this.isSelectGiro = false;
    },
    findAgain: function findAgain() {
      this.ruc = null;
      this.businessName = null;
      this.isSuccess = false;
      this.isValidate = false;
      this.invalidMessage = null;
      this.commercialBusiness = null;
      this.$v.$reset();
    },
    verifyRucFormat: function verifyRucFormat(ruc) {
      var fixFactors = "5432765432";

      var sum = new (Function.prototype.bind.apply(Array, [null].concat(_toConsumableArray(ruc.substring(0, 10)))))().map(function (digit, index) {
        return Number(digit) * Number(fixFactors[index]);
      }).reduce(function (prev, next) {
        return prev + next;
      });

      var complement = 11 - sum % 11;

      switch (complement) {
        case 11:
        case 1:
          complement = 1;
          break;
        case 10:
        case 0:
          complement = 0;
          break;
      }

      return ruc % 10 === complement % 10;
    },
    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref2, statusCode, internalStatusCode, internalStatusDescription, businessName, isClientVisanet;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$v.$touch();

                if (!this.$v.$invalid) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:

                this.loading = true;
                this.$refs.loaderModal.showLoader();

                _context.prev = 5;

                if (!this.isSuccess) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return this.$store.dispatch("affiliations/form/saveRuc", {
                  ruc: this.ruc,
                  businessName: this.businessName,
                  consultDate: this.consultDate
                });

              case 9:
                _context.next = 35;
                break;

              case 11:
                this.isValidate = false;

                if (this.verifyRucFormat(this.ruc)) {
                  _context.next = 14;
                  break;
                }

                throw new WarningError("El formato de ruc es incorrecto");

              case 14:
                _context.next = 16;
                return this.$store.dispatch("affiliations/form/getRucValidation", this.ruc);

              case 16:
                _ref2 = _context.sent;
                statusCode = _ref2.statusCode;
                internalStatusCode = _ref2.internalStatusCode;
                internalStatusDescription = _ref2.internalStatusDescription;
                businessName = _ref2.businessName;

                if (!(statusCode !== "0")) {
                  _context.next = 27;
                  break;
                }

                _context.t0 = internalStatusCode;
                _context.next = _context.t0 === null ? 25 : 26;
                break;

              case 25:
                throw new WarningError("El campo de respuesta ValidateClientInqOperRs.Status.AdditionalStatus.StatusCode es nulo");

              case 26:
                throw new WarningError(internalStatusDescription);

              case 27:

                this.consultDate = this.$moment().format("YYYY-MM-DD");

                _context.next = 30;
                return this.$store.dispatch("affiliations/form/getListcommerce", this.ruc);

              case 30:
                isClientVisanet = _context.sent;

                isClientVisanet === "1" ? this.isVisanetClient = true : this.isVisanetClient = false;

                this.businessName = businessName;
                this.isValidate = true;
                this.isSuccess = true;

              case 35:
                _context.next = 40;
                break;

              case 37:
                _context.prev = 37;
                _context.t1 = _context["catch"](5);

                if (_context.t1 instanceof WarningError) {
                  this.invalidMessage = _context.t1.message;
                  this.isValidate = true;
                } else this.$controlMessage(_context.t1);

              case 40:

                this.loading = false;
                this.$refs.loaderModal.closeLoader();

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 37]]);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    consultMcci: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mcci) {
        var data, _ref4, codigo, mensaje, mensajeMantenimiento;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (mcci) {
                  _context2.next = 4;
                  break;
                }

                this.isSelectGiro = true;
                this.tableComision = false;
                return _context2.abrupt("return");

              case 4:
                this.loading = true;
                this.$refs.loaderModal.showLoader();

                _context2.prev = 6;
                data = {
                  audit: {
                    appId: "PCRM001V1",
                    usuario: "",
                    ipServidor: "",
                    transaccionId: "",
                    origen: ""
                  },
                  obtenerComisionesRequest: {
                    cliente: {
                      ruc: this.ruc,
                      oportunidad: {
                        producto: "",
                        subProducto: "",
                        mccInternacional: mcci,
                        plataforma: ""
                      }
                    }
                  }
                };
                _context2.next = 10;
                return this.$store.dispatch("affiliations/form/consultComision", data);

              case 10:
                _ref4 = _context2.sent;
                codigo = _ref4.codigo;
                mensaje = _ref4.mensaje;

                this.tableComision = true;
                mensajeMantenimiento = "El servicio no se encuentra disponible";

                if (!(codigo !== "0000")) {
                  _context2.next = 19;
                  break;
                }

                if (!(mensaje == "")) {
                  _context2.next = 18;
                  break;
                }

                throw new WarningError(mensajeMantenimiento);

              case 18:
                throw new WarningError(mensaje);

              case 19:
                _context2.next = 24;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](6);

                this.$controlMessage(_context2.t0);

              case 24:
                this.loading = false;
                this.$refs.loaderModal.closeLoader();

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 21]]);
      }));

      function consultMcci(_x) {
        return _ref3.apply(this, arguments);
      }

      return consultMcci;
    }(),
    tableComissionClose: function tableComissionClose() {
      this.commercialBusiness = null;
      this.tableComision = false;
      this.dialog = false;
      //this.isSelectGiro = false;
    },
    listenerAutocomplete: function listenerAutocomplete(valor) {
      var optselected = this.opCommercialBusiness.find(function (opt) {
        return opt.Code == valor;
      });
      // console.log(optselected);
      this.commercialBusiness = optselected;
      this.setCodeMcci(valor);
    }
  },
  computed: _extends({}, mapState({
    opCommercialBusiness: function opCommercialBusiness(state) {
      // console.log(state["master-data"].opCommercialBusiness);
      return state["master-data"].opCommercialBusiness;
    }
  }), {
    desktop: function desktop() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    rucErrorMessage: function rucErrorMessage() {
      var errors = [];
      if (!this.$v.ruc.$dirty) return errors;
      !this.$v.ruc.required && errors.push("Campo obligatorio"), !this.$v.ruc.numeric && errors.push("Ingresa sólo números"), !this.$v.ruc.minLength && errors.push("El N° ingresado debe tener 11 dígitos");
      return errors;
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/ruc-validations.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/ruc-validations.vue
// module chunks = 0 1 2 3